import { useEffect } from "react";

declare global {
  interface Window {
    BrevoConversationsID?: string;
    BrevoConversations?: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

export default function BrevoWidget() {
  useEffect(() => {
    window.BrevoConversationsID = "68dab2e587998b80350aca1a";
    window.BrevoConversations =
      window.BrevoConversations ||
      function (...args: unknown[]) {
        (window.BrevoConversations!.q = window.BrevoConversations!.q || []).push(args);
      };

    const existingScript = document.querySelector(
      'script[src="https://conversations-widget.brevo.com/brevo-conversations.js"]',
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://conversations-widget.brevo.com/brevo-conversations.js";
      document.head.appendChild(script);
    }

    window.BrevoConversations?.("show");
  }, []);

  return null;
}
